import NextLink from 'next/link';
import { styled } from '@mui/material/styles';

import type { XNavLinkProps } from './types';

const StyledNavLink = styled(NextLink)(() => ({ textDecoration: 'none' }));

export function XNavLink({ children, webOnlyPassHref, ...props }: XNavLinkProps) {
  return (
    <StyledNavLink passHref={webOnlyPassHref} {...props}>
      {children}
    </StyledNavLink>
  );
}
